export const CLOSE_DOCUMENTS_DELETION_DIALOG = 'CLOSE_DOCUMENTS_DELETION_DIALOG'
export const DELETE_FILDERS = 'DELETE_FILDERS'
export const OPEN_DOCUMENTS_DELETION_DIALOG = 'OPEN_DOCUMENTS_DELETION_DIALOG'
